// extracted by css-extract-rspack-plugin
export default {"listContainer":"List-module__listContainer__VHzGA"};